import {Time} from 'yougile-util'
import {AggregatedDeadlineProps, DeadlineStatus} from './types'

export const getDeadlineStatus = (
  props: AggregatedDeadlineProps
): DeadlineStatus => {
  if (!props.items || !props.items.length) {
    return {status: 'in-progress', date: undefined}
  }
  const deadlinesCompleted = props.items
    .map(x => (x?.completed ? x?.deadline?.deadline : undefined))
    .filter(Boolean)
  const deadlinesIncompleted = props.items
    .map(x => (x.completed ? undefined : x.deadline?.deadline))
    .filter(Boolean)
  const startDates = props.items.map(x => x.deadline?.startDate).filter(Boolean)

  if (
    !deadlinesCompleted.length &&
    !deadlinesIncompleted.length &&
    !startDates.length
  ) {
    return {status: 'in-progress', date: ''}
  }

  const minDeadlineIncomplete = Math.min(...deadlinesIncompleted)

  const minDeadlineDate = Math.min(
    ...deadlinesIncompleted,
    ...deadlinesCompleted
  )
  const minDate = Math.min(...startDates, minDeadlineDate)
  const maxDate = Math.max(...deadlinesCompleted, ...deadlinesIncompleted)
  const minStartDate = Time.formatDate(minDate)
  const maxDeadline = Time.formatDate(maxDate)
  const now = Time.now()

  const expired = now > minDeadlineIncomplete
  const date =
    minStartDate === maxDeadline
      ? minStartDate
      : `${minStartDate}-${maxDeadline}`

  return {
    status:
      deadlinesIncompleted.length === 0
        ? 'completed'
        : expired
          ? 'expired'
          : 'in-progress',
    date,
    start: minDate,
    end: maxDate
  }
}
